import { render, staticRenderFns } from "./AgreeBeforeBooking.vue?vue&type=template&id=1618b608&scoped=true&"
import script from "./AgreeBeforeBooking.vue?vue&type=script&lang=js&"
export * from "./AgreeBeforeBooking.vue?vue&type=script&lang=js&"
import style0 from "./AgreeBeforeBooking.vue?vue&type=style&index=0&id=1618b608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1618b608",
  null
  
)

export default component.exports